import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { OptionalMessage } from '../OptionalMessage/OptionalMessage.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

var _excluded = ["id", "label", "isOptional", "tooltipText"];

/* eslint-disable @typescript-eslint/no-explicit-any */

var InputLabel = props => {
  var {
      id,
      label,
      isOptional,
      tooltipText
      // eslint-disable-line
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  var TooltipTextComponent; // eslint-disable-line

  attributes.htmlFor = id;
  var hcid = "".concat(InputLabel.name.toLocaleLowerCase(), "-").concat("10.6.2");
  var onLabelClick = event => {
    if (tooltipText) {
      event.preventDefault();
    }
  };
  if (tooltipText) {
    TooltipTextComponent = /*#__PURE__*/React.createElement(Tooltip, {
      text: label,
      tooltipText: tooltipText,
      icon: true,
      id: "".concat(id, "-helptext")
    });
    attributes.onClick = onLabelClick;
  }

  /* eslint-disable react/jsx-no-useless-fragment */
  var renderLabel = () => {
    if (isOptional) {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(React.Fragment, null, tooltipText ? TooltipTextComponent : label, /*#__PURE__*/React.createElement(OptionalMessage, null)));
    } else {
      // eslint-disable-line
      return /*#__PURE__*/React.createElement(React.Fragment, null, tooltipText ? TooltipTextComponent : label);
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    React.createElement("label", _extends({}, attributes, {
      "data-hcid": hcid
    }), renderLabel())
  );
};
InputLabel.propTypes = {
  id: PropTypes.string.isRequired,
  isOptional: PropTypes.bool,
  label: PropTypes.string.isRequired,
  tooltipText: PropTypes.string
};

export { InputLabel };
